import {Typography} from '@yandex-delivery/ui'
import React from 'react'

import type {LngLat} from '../../../map'
import {TariffsMapMarker} from '../TariffsMapMarker'
import styleClasses from './classes.module.css'

type Props = {
  coordinates: LngLat
  value: string
  onClick?: VoidFunction
}

export function City({coordinates, value, onClick}: Props) {
  return (
    <TariffsMapMarker coordinates={coordinates}>
      <div className={styleClasses.city} onClick={onClick}>
        <Typography color="textInvert" density="tight" level="body2" weight="regular">
          {value}
        </Typography>
      </div>
    </TariffsMapMarker>
  )
}
